// @flow
import FeatureFlags from "../../../FeatureFlags";

import OldFinalPopup, { StartPopup, NewFinalPopup } from "./Final";
import JoinPopup from "./Join";
import LeavePopup from "./Leave";
import RefillPopup from "./Refill";

const FinalPopup = FeatureFlags.enableNewFinalPopup
  ? NewFinalPopup
  : OldFinalPopup;

export { FinalPopup, StartPopup, JoinPopup, LeavePopup, RefillPopup };



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/index.js